import { styled } from "@mui/styles";
import { Box, Container } from "@mui/material";

export const StyledContainer = styled(Container)(({ theme }) => ({
    display: 'flex !important',
    flexFlow: 'column !important',
    gap: '50px !important',

    [theme.breakpoints.up('md')]: {
        marginTop: '50px'
    },

    '& .IntroSection': {
        '& img': {
            borderRadius: '15px',
            border: '1px solid #eee',
            boxShadow: '0 0.3125rem 1rem -0.1875rem rgb(0 0 0 / 30%)',
            width: '100%',
            [theme.breakpoints.up('md')]:
            {
                height: '400px',
                width: '475px',
                objectFit: 'cover'
            }
        },

        '& h4': {
            [theme.breakpoints.down('md')]: {
                fontSize: '1.5rem'
            }
        }
    },
    '& p': {
        color: '#717171'
    },
    '& h5, .BoldHeading': {
        fontWeight: 600,
        color: 'black'
    },
    '& .BulletPoint': {
        display: 'flex', alignItems: 'center', gap: '10px'
    },
    '& .BulletPoint .MuiSvgIcon-root': {
        fontSize: '10px'
    },
    '& .SupporterDescription': {
        fontSize: '14px', color: 'white', minHeight: '70px'
    },
    '& .BulletPointsContainer': {
        marginTop: '30px',
    },
    '& .BulletPointsContainer ul': {
        paddingLeft: '18px',
    },
    '& .BulletPointsContainer .MuiBox-root': {
        [theme.breakpoints.up('md')]:
        {
            width: '33.33%'
        },
    },
    '& .MoreQuestionsSection p': {
        [theme.breakpoints.up('md')]: {
            width: '40%'
        }
    },
    '& .Section2Desc': {
        [theme.breakpoints.up('md')]: {
            width: '50%'
        }
    },
    '& .GetInspiredCards': {
        marginTop: '30px'
    },
    '& .StartYourFundraiserButton': {
        '&:hover': {
            color: 'white'
        }
    }
}));

export const StyledBox = styled(Box)(({ theme }) => ({
    background: '#eee',
    marginTop: '50px',
    marginBottom: '-45px',

    '& p': {
        [theme.breakpoints.up('md')]: {
            width: '40%'
        }
    },
    '& .MuiContainer-root': {
        // marginTop: '50px',
        paddingTop: '70px',
        paddingBottom: '70px',
        // marginBottom: '-50px'
    },
    '& h5': {
        fontWeight: 600
    },
}));